const doc = [({"en":({"js":({"admin":({"highscore_class_steps":({"table":({"the_class_step_was_removed_from_the_highscore":"The class step was removed from the highscore"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;